import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import TabTittle from '../components/TabTittle'
import ToploaderBar from '../components/ToploaderBar'
import MainAPI from '../assets/APIs/mainApi'

const pdfData = {
    "তথ্য প্রদানকারী কর্মকর্তা": "/notice/CamScanner 06-11-2026 09.30.pdf",
    "বিকল্প তথ্য প্রদানকারী কর্মকর্তা": "/notice/CamScanner 06-11-2026 09.30.pdf",
    "আপীল কর্তৃপক্ষ": "/notice/CamScanner 06-11-2026 09.30.pdf",
}

function Survices() {
    TabTittle("জেলা পরিষদ, রাজশাহী।")
    const { i } = useParams()
    const UpdateData = MainAPI.ServInfo.filter((e, index) => {
        return index == i
    })
    const title = UpdateData[0]?.list[0]?.tittle
    const pdfUrl = pdfData[title]

    return (
        <>
            <ToploaderBar />
            <div className='colam'>
                {pdfUrl ? (
                    <iframe
                        src={pdfUrl}
                        title={title}
                        style={{ width: '100%', height: '80vh', border: 'none' }}
                    />
                ) : (
                    <h1>{title} এর জন্য কোন তথ্য নেই!</h1>
                )}
            </div>
        </>
    )
}

export default Survices